import { render, staticRenderFns } from "./GenreList.vue?vue&type=template&id=53666826&scoped=true"
import script from "./GenreList.vue?vue&type=script&lang=js"
export * from "./GenreList.vue?vue&type=script&lang=js"
import style0 from "./GenreList.vue?vue&type=style&index=0&id=53666826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53666826",
  null
  
)

export default component.exports